import {Button} from 'primereact/button'

const AuditLogButton = ({label, onClick = () => {}}) => {
    const fontSize = 'text-xs sm:text-xs md:text-md lg:text-lg'
    return (
        <Button
            label={label}
            className={` gap-1  ${fontSize} white-space-nowrap w-20rem bg-gray-700 border-0`}
            icon="pi pi-download"
            onClick={onClick}
        />
    )
}

export default AuditLogButton
